<template>
  <Container type="card-full">
    <div slot="header">
      <!-- <el-button v-if="type === 1 && showButton == 0"  @click="addPsu">新增</el-button>
      <el-button v-if="type === 1 && showButton == 0"  @click="delPsu">删除</el-button> -->
      <!-- <el-button  @click="close">关闭</el-button> --> 
    </div>
    <div class="container">
      <vggrid ref="xGrid" class="vggrid" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"
              :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
      >
          <template slot="btn">
            <div class="btn-box">
              <vxe-button  icon="vxe-icon--plus" type="text"  @click="addPsu">新增</vxe-button>
            </div>
            <!-- <vxe-button  icon="vxe-icon--plus" status="perfect" v-if="type === 1 && showButton == 0"  @click="delPsu">删除</vxe-button> -->
          </template>
      </vggrid>
      <!-- <el-form :model="pinviteCom" ref="form"  class="content ss-fl" v-if="psuform">
        <el-row>
          <el-col :span="40">
            <el-form-item label="供应商" prop="pinviteComInfo" verify :label-width="formLabelWidth">
              <el-select v-model="form.psucomid" filterable :clearable="true" :disabled="type === 2?true:false">
                <el-option v-for="(item, index) in comList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
              <el-autocomplete
                class="inline-input"
                v-model="pinviteCom.pinviteComInfo"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                :trigger-on-focus="false"
                @select="handleSelect"
              >
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button v-if="type === 1" type="primary" @click="savePsu">保存</el-button>
          <el-button v-if="type === 2" type="primary" @click="confirmPsu">确认参加</el-button>
          <el-button type="danger" @click="delPsu">删除</el-button>
        </el-form-item>
      </el-form> -->
      <div class="content ss-fl" v-if="psuform">
            <div class="serch">
                <el-input
                  placeholder="请输入内容"
                  v-model="query.comcodename"
                  clearable @input="changeInput">
                </el-input>
                <el-button icon="el-icon-search" style="margin-left:20px;" @click="searchCom">搜索</el-button>
            </div>
            <div class="table-vex">
              <vggrid ref="xGrid" class="vggrid-two" :list="GYSlist" tableheight="700" flexname=""
                      :cols="GYScols" :showfooter="false" :showPage="true" :resizable="true"
                       @pagechange="pagechange" :total="query.total" 
                      @cellClick="cellClick"
              >
                  <template slot="btn">
                    <div class="btn-box">
                      <el-button type="primary" size="small" @click="saveGYSinfo">邀请</el-button>
                    </div>
                    <!-- <vxe-button  icon="vxe-icon--plus" status="perfect" v-if="type === 1 && showButton == 0"  @click="delPsu">删除</vxe-button> -->
                  </template>
              </vggrid>
            </div>
      </div>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import vggrid from '../common/vggrid'
  import moment from 'moment'
  export default {
    name: 'pInviteForm',
    mixins: [common],
    data () {
      return {
        list: [],
        GYSlist:[],
        comList:[],
        project: this.$route.params.form,
        type: this.$route.params.type, //是供应商确认界面还是邀请界面
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { field: 'syscodename', fieldtype: 'C', title: '确认标识',calculExpr:'',addNewRowFlg: false, 
          slots: {
            default: ({ row }) => {
              if (+row.psustatus === 1)
                return [<div style="text-align: center">待接受</div>]
              if (+row.psustatus === 3)
                return [<div style="text-align: center">确认参加</div>]
              else
                return [<span>{row.syscodename}</span>]
            },
          },},
          { field: 'psuusername', fieldtype: 'C', title: '确认人',calculExpr:'',addNewRowFlg: false},
          { field: 'psutime', fieldtype: 'C', title: '确认时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        GYScols:[
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          { type: 'checkbox', width: 60 },
        ],
        query: {
          total: 0,
          limit: 20,
          offset: 0,
          comtype: ''
        },
        psuform: false,
        form: {},
        pinviteCom:{
          pinviteComInfo:''
        },
        loading: true,
        formLabelWidth: '150px',
        isOperate:true,
        operateBtn:[
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        showButton:Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      }
    },
    created () {
      this.$on('DEL', () => this.delPsu())
    },
    activated() {
      this.init()
      this.getPsuList()
      this.getComList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.list = []
        this.comList = []
        this.project = this.$route.params.form
        this.type = this.$route.params.type //是供应商确认界面还是邀请界面
        this.form = {}
        this.pinviteCom.pinviteComInfo = ''
        this.psuform = false
        this.showButton = Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      },
      changeInput(e){
        this.query.comcodename = e.replace(/[, ]/g,'')
      },
      async addPsu () {
        this.psuform = true
        this.pinviteCom.pinviteComInfo = ''
        this.form = {
          psuid: 0,
          psutype: '2',
          psubmcheckuserid: this.$store.getters.loginUser.userid,
          psuprojectid: this.project.projectid,
          psustatus: '1',
          psubmamt: this.project.projectbmamt,
          psubzjamt: this.project.projectbzjamt,
          psuchargeflg: this.project.prschangeflg
        }
        this.GYSlist = []
      },
      vggridClick(code,row){
        this.form = row
        this.$emit(code,row)
      },
      async getComList() {
        this.comList = await request({
          url: '/ywgl/com/getComList',
          method: "get",
          params: {
            cosid:this.$store.getters.loginUser.cosid
          }
        })
        this.comList.forEach(e=>{
          e.value = e.label
        })

      },
      querySearch(queryString, cb) {
        var item = this.comList;
        var results = queryString ? item.filter(this.createFilter(queryString)) : item;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (item) => {
          return (item.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        this.form.psucomid = item.comid
      },
      async delPsu (row) {
        if(this.form.psuuserid){
          this.$message.error('供应商已经确认报名，不能删除！')
          return
        }
        // if (this.project.projectstatus!=='10') {
        //   this.$message.error('项目公告已发布，不能删除已邀请的供应商！')
        //   return
        // }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xmgl/project/delPsu',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getPsuList()
            this.$message.success('删除成功！')
          }
        })
      },
      async savePsu () {
        this.submitForm('form').then(async() => {
          // if (this.project.projectstatus!=='10') {
          //   this.$message.error('项目公告已发布，不能新增/修改！')
          //   return
          // }
          await request({
            url: '/xmgl/project/savePsuInvite',
            method: "post",
            data: this.form
          })
          this.$message.success('操作成功')
          await this.getPsuList()
          this.psuform = false
        }).catch(() => {})
      },
      async confirmPsu() {
        let model = {
          selectRecords: [this.form]
        }
        if (this.type === 2) {
          await request({
            url: '/xmgl/project/savePsuConfirm',
            method: "post",
            data: model
          })
          this.$message.success('确认参加成功！')
          await this.getPsuList()
          this.psuform = false
        }
      },
      async cellClick (row) {
        this.pinviteCom.pinviteComInfo = row.row.comfullname
        this.form = row.row
        // this.psuform = true
      },
      async getPsuList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getInvitePsuListByProjectId',
          params: {projectid: this.project.projectid,type: this.type,comid:this.$store.getters.loginUser.comid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        if (this.type === 1) {//是邀请界面
          let returnForm = 'projectIndex'
          if (this.project.projecttype === '2') {
            returnForm = 'projectZjIndex'
          }
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
        } else {//供应商确认界面
          this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
        }
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.query.comtype = 3
        this.query.isInivte = true
        this.query.projectid = this.project.projectid

        let res = await request({
          method: 'get',
          url: '/ywgl/com/getPageList',
          params: this.query
        })
        this.GYSlist = res.list
        this.query.total = res.count[0].count
      },
      async searchCom(){
        this.query.offset = 0
        this.query.comtype = 3
        this.query.isInivte = true
        this.query.projectid = this.project.projectid

        let res = await request({
          method: 'get',
          url: '/ywgl/com/getPageList',
          params: this.query
        })
        this.GYSlist = res.list
        this.query.total = res.count[0].count
      },
      async saveGYSinfo(){
        if(moment(new Date()).isAfter(this.project.prsbmendtime)){
            this.$message.warning('报名时间已结束，不能邀请单位')
            return
        }
        let selectRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        console.log('selectRecords',selectRecords);
        if (!selectRecords.length) {
          this.$message.warning('请选择成交供应商！')
          return
        }
        selectRecords.forEach(e=>{
          e.psuid = 0,
          e.psutype = 2,
          e.psubmcheckuserid= this.$store.getters.loginUser.userid,
          e.psucomid= e.comid,
          e.psuprojectid= this.project.projectid,
          e.psustatus= '1',
          e.psubmamt= this.project.projectbmamt,
          e.psubzjamt= this.project.projectbzjamt,
          e.psuchargeflg= this.project.prschangeflg
        })
        await request({
          url: '/xmgl/project/savePsuInvite',
          method: "post",
          data: selectRecords
        })
        this.$message.success('操作成功')
        await this.getPsuList()
        this.psuform = false
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .btn-box{
    overflow: hidden;
      .vxe-button{
        padding: 10px 10px;
        font-size: 16px;
      }
  }
  .container {
    display: flex;
    .vggrid {
      border: 1px solid #d1dbe5;
      width: 600px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }

  .serch{
    display: flex;
    margin: 0 20px;
  }
  .table-vex{
    margin: 20px 20px;
  }
</style>
